
(function() {
  var result = { translations: { "sv": { "SharedI18nStrings": { "languageNames": { "af": "Afrikaans", "sq": "Albanska", "sq-al": "Albanska \u2013 Albanien", "ar": "Arabiska", "ar-dz": "Arabiska \u2013 Algeriet", "ar-bh": "Arabiska \u2013 Bahrain", "ar-eg": "Arabiska \u2013 Egypten", "ar-iq": "Arabiska \u2013 Irak", "ar-jo": "Arabiska \u2013 Jordanien", "ar-kw": "Arabiska \u2013 Kuwait", "ar-lb": "Arabiska \u2013 Libanon", "ar-ly": "Arabiska \u2013 Libyen", "ar-ma": "Arabiska \u2013 Marocko", "ar-om": "Arabiska \u2013 Oman", "ar-qa": "Arabiska \u2013 Qatar", "ar-sa": "Arabiska \u2013 Saudiarabien", "ar-sd": "Arabiska \u2013 Sudan", "ar-sy": "Arabiska \u2013 Syrien", "ar-tn": "Arabiska \u2013 Tunisien", "ar-ae": "Arabiska \u2013 F\xF6renade Arabemiraten", "ar-ye": "Arabiska \u2013 Jemen", "as": "Assamiska", "az": "Azerbajdzjanska", "hy": "Armeniska", "eu": "Baskiska", "be": "Vitryska", "be-by": "Vitryska \u2013 Vitryssland", "bn": "Bengali", "bg": "Bulgariska", "bg-bg": "Bulgariska \u2013 Bulgarien", "bs": "Bosniska", "ca": "Katalanska", "ca-es": "Katalanska \u2013 Katalonien", "zh": "Kinesiska", "zh-cn": "Kinesiska - f\xF6renklat", "zh-hk": "Kinesiska - Hong Kong", "zh-mo": "Kinesiska \u2013 Macao", "zh-sg": "Kinesiska \u2013 Singapore", "zh-tw": "Kinesiska - traditionell", "zh-chs": "Kinesiska (f\xF6renklad)", "zh-cht": "Kinesiska (traditionell)", "zh-hans": "Kinesiska (f\xF6renklad Han)", "zh-hant": "Kinesiska (traditionell Han)", "hr": "Kroatiska", "hr-hr": "Kroatiska \u2013 Kroatien", "cs": "Tjeckiska", "cs-cz": "Tjeckiska \u2013 Tjeckien", "da": "Danska", "da-dk": "Danska \u2013 Danmark", "nl": "Nederl\xE4ndska", "nl-be": "Nederl\xE4ndska \u2013 Belgien", "nl-ch": "Nederl\xE4ndska - Schweiz", "nl-lu": "Holl\xE4ndska - Luxemburg", "nl-nl": "Nederl\xE4ndska \u2013 Nederl\xE4nderna", "en": "Engelska", "en-ae": "Engelska - F\xF6renade Arabemiraten", "en-au": "Engelska \u2013 Australien", "en-be": "Engelska - Belgien", "en-ca": "Engelska \u2013 Kanada", "en-ch": "Engelska - Schweiz", "en-cn": "Engelska - Kina", "en-de": "Engelska \u2013 Tyska", "en-ee": "Engelska - Estland", "en-es": "Engelska - Spanien", "en-fr": "Engelska - Frankrike", "en-hk": "Engelska \u2013 Hongkong", "en-in": "Engelska \u2013 Indien", "en-ie": "Engelska - Irland", "en-ke": "Engelska - Kenya", "en-lu": "Engelska - Luxemburg", "en-my": "Engelska \u2013 Malaysia", "en-mt": "Engelska \u2013 Malta", "en-mx": "Engelska \u2013 Mexiko", "en-nl": "Engelska - Nederl\xE4nderna", "en-nz": "Engelska \u2013 Nya Zeeland", "en-ph": "Engelska \u2013 Filippinerna", "en-pk": "Engelska - Pakistan", "en-se": "Engelska - Sverige", "en-sg": "Engelska \u2013 Singapore", "en-tn": "Engelska - Tunisien", "en-za": "Engelska \u2013 Sydafrika", "en-gb": "Engelska - Storbritannien", "en-us": "Engelska - USA", "en-zw": "Engelska \u2013 Zimbabwe", "et": "Estniska", "et-ee": "Estniska \u2013 Estland", "fo": "F\xE4r\xF6iska", "fa": "Farsi", "fi": "Finska", "fi-fi": "Finska \u2013 Finland", "fil": "Filippinska", "fr": "Franska", "fr-be": "Franska \u2013 Belgien", "fr-ca": "Franska \u2013 Kanada", "fr-fr": "Franska \u2013 Frankrike", "fr-lu": "Franska \u2013 Luxemburg", "fr-mc": "Franska \u2013 Monaco", "fr-ch": "Franska \u2013 Schweiz", "fr-tn": "Franska - Tunisien", "gl": "Galisiska", "ka": "Georgiska", "de": "Tyska", "de-at": "Tyska \u2013 \xD6sterrike", "de-de": "Tyska \u2013 Tyskland", "de-gr": "Tyska \u2013 Grekland", "de-li": "Tyska \u2013 Lichtenstein", "de-lu": "Tyska \u2013 Luxemburg", "de-ch": "Tyska \u2013 Schweiz", "el": "Grekiska", "el-cy": "Grekiska \u2013 Cypern", "el-gr": "Grekiska \u2013 Grekland", "gu": "Gujarati", "haw": "Hawaiiska", "ha": "Hausa", "he": "Hebreiska", "he-il": "Hebreiska \u2013 Israel", "iw-il": "Hebreiska \u2013 Israel", "hi": "Hindi", "hi-in": "Hindi \u2013 Indien", "hu": "Ungerska", "hu-hu": "Ungerska \u2013 Ungern", "is": "Isl\xE4ndska", "is-is": "Isl\xE4ndska \u2013 Island", "id": "Indonesiska", "in-id": "Indonesiska \u2013 Indonesien", "ga": "Irl\xE4ndsk", "ga-ie": "Iriska \u2013 Irland", "it": "Italienska", "it-it": "Italienska \u2013 Italien", "it-ch": "Italienska \u2013 Schweiz", "ja": "Japanska", "ja-jp": "Japanska \u2013 Japan", "kn": "Kannada", "kk": "Kazakiska", "kok": "Konkani", "ko": "Koreanska", "ko-kr": "Koreanska \u2013 Sydkorea", "ku": "Kurdiska", "ky": "Kirgiziska", "ky-kg": "Kirgiziska", "lo": "Lao", "lv": "Lettiska", "lv-lv": "Lettiska \u2013 Lettland", "lt": "Litauiska", "lt-lt": "Litauiska \u2013 Litauen", "mk": "Makedonska", "mk-mk": "Makedonska \u2013 Makedonien", "ml": "Malayalam", "ms": "Malajiska", "ms-bn": "Malajiska \u2013 Brunei", "ms-my": "Malajiska \u2013 Malaysia", "mt": "Maltesiska", "mt-mt": "Maltesiska \u2013 Malta", "mr": "Marathi", "mn": "Mongoliska", "my": "Burmesiska", "my-mm": "Burmesiska \u2013 Myanmar (Burma)", "ne": "Nepalesiska", "no": "Norska", "nb": "Norska (bokm\xE5l)", "nb-no": "Norska Bokmal - Norge", "no-no": "Norska \u2013 Norge", "pl": "Polska", "pl-pl": "Polska \u2013 Polen", "pt": "Portugisiska", "pt-br": "Portugisiska \u2013 Brasilien", "pt-pt": "Portugisiska \u2013 Portugal", "pa": "Punjabi", "pa-in": "Punjabi - Indien", "pa-pk": "Punjabi - Pakistan", "ro": "Rum\xE4nska", "ro-ro": "Rum\xE4nska \u2013 Rum\xE4nien", "ru": "Ryska", "ru-ru": "Ryska \u2013 Ryssland", "rw-rw": "Kinyarwanda", "sa": "Sanskrit", "si": "Singalesiska", "sr": "Serbiska", "sr-ba": "Serbiska \u2013 Bosnien och Hercegovina", "sr-me": "Serbiska \u2013 Montenegro", "sr-rs": "Serbiska \u2013 Serbien", "sr-cs": "Serbiska \u2013 Serbien och Montenegro (f.d.)", "sk": "Slovakiska", "sk-sk": "Slovakiska \u2013 Slovakien", "sl": "Slovenska", "sl-si": "Slovenska \u2013 Slovenien", "es": "Spanska", "es-ar": "Spanska \u2013 Argentina", "es-bo": "Spanska \u2013 Bolivia", "es-cl": "Spanska \u2013 Chile", "es-co": "Spanska \u2013 Colombia", "es-cr": "Spanska \u2013 Costa Rica", "es-cu": "Spanska \u2013 Kuba", "es-do": "Spanska \u2013 Dominikanska republiken", "es-ec": "Spanska \u2013 Ecuador", "es-sv": "Spanska \u2013 El Salvador", "es-gt": "Spanska \u2013 Guatemala", "es-hn": "Spanska \u2013 Honduras", "es-mx": "Spanska \u2013 Mexiko", "es-ni": "Spanska \u2013 Nicaragua", "es-pa": "Spanska \u2013 Panama", "es-py": "Spanska \u2013 Paraguay", "es-pe": "Spanska \u2013 Peru", "es-pr": "Spanska \u2013 Puerto Rico", "es-es": "Spanska \u2013 Spanien", "es-us": "Spanska \u2013 USA", "es-uy": "Spanska \u2013 Uruguay", "es-ve": "Spanska \u2013 Venezuela", "sw": "Swahili", "sv": "Svenska", "sv-fi": "Svenska \u2013 Finland", "sv-se": "Svenska \u2013 Sverige", "sy": "Syriska", "ta": "Tamil", "tt": "Tatar", "te": "Telugu", "th": "Thail\xE4ndska", "th-th": "Thai \u2013 Thailand", "tl": "Tagalog", "tr": "Turkiska", "tr-tr": "Turkiska \u2013 Turkiet", "uk": "Ukrainska", "uk-ua": "Ukrainska \u2013 Ukraina", "ur": "Urdu", "uz": "Uzbekiska", "vi": "Vietnamesiska", "vi-vn": "Vietnamesiska \u2013 Vietnam", "yi": "Jiddisch", "zu": "Zulu" } } } } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "SharedI18nStrings": {
    "af": "static-1.161",
    "ar-eg": "static-1.161",
    "ar-sa": "static-1.161",
    "ar": "static-1.161",
    "be": "static-1.161",
    "bg": "static-1.161",
    "bn": "static-1.161",
    "ca-es": "static-1.161",
    "ca": "static-1.161",
    "cs": "static-1.161",
    "da": "static-1.161",
    "de": "static-1.161",
    "el": "static-1.161",
    "en-gb": "static-1.161",
    "en": "static-1.161",
    "es-ar": "static-1.161",
    "es-es": "static-1.161",
    "es-mx": "static-1.161",
    "es": "static-1.161",
    "et": "static-1.161",
    "eu": "static-1.161",
    "fi": "static-1.161",
    "fr-ca": "static-1.161",
    "fr": "static-1.161",
    "gl": "static-1.161",
    "gu": "static-1.161",
    "he-il": "static-1.161",
    "he": "static-1.161",
    "hi": "static-1.161",
    "hr": "static-1.161",
    "hu": "static-1.161",
    "hy": "static-1.161",
    "id": "static-1.161",
    "is": "static-1.161",
    "it": "static-1.161",
    "ja": "static-1.161",
    "ka": "static-1.161",
    "kk": "static-1.161",
    "kn": "static-1.161",
    "ko": "static-1.161",
    "ky": "static-1.161",
    "lt": "static-1.161",
    "lv": "static-1.161",
    "mk": "static-1.161",
    "mn": "static-1.161",
    "mr": "static-1.161",
    "ms-my": "static-1.161",
    "ms": "static-1.161",
    "nl-be": "static-1.161",
    "nl-nl": "static-1.161",
    "nl": "static-1.161",
    "no": "static-1.161",
    "pl": "static-1.161",
    "pt-br": "static-1.161",
    "pt-pt": "static-1.161",
    "ro": "static-1.161",
    "ru": "static-1.161",
    "sk": "static-1.161",
    "sl": "static-1.161",
    "sq": "static-1.161",
    "sr": "static-1.161",
    "sv": "static-1.161",
    "sw": "static-1.161",
    "ta": "static-1.161",
    "te": "static-1.161",
    "th": "static-1.161",
    "tl": "static-1.161",
    "tr": "static-1.161",
    "uk": "static-1.161",
    "ur": "static-1.161",
    "vi": "static-1.161",
    "zh-cn": "static-1.161",
    "zh-hans": "static-1.161",
    "zh-hant": "static-1.161",
    "zh-hk": "static-1.161",
    "zh-tw": "static-1.161"
  }
};
  hns('I18n', result);

})();



(function() {
  var result = { translations: { "sv": { "i18n": { "duration": { "seconds": "{{ seconds }} sek", "minutes": "{{ minutes }} min", "hours": "{{ hours }} tim", "hoursAndMinutes": "{{ hours }} tim {{ minutes }} min", "days": "{{ days }} dagar", "shortForm": { "seconds": "{{ seconds }}sek", "minutes": "{{ minutes }}min", "hours": "{{ hours }}tim", "days": "{{ days }}dagar", "hoursAndMinutes": "{{ hours }}tim {{ minutes }}min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }} / {{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, anknytning {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sv": "static-7.1359"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1359",
    "ar-eg": "static-7.1359",
    "bg": "static-7.1359",
    "bn": "static-7.1359",
    "ca-es": "static-7.1359",
    "cs": "static-7.1359",
    "da": "static-7.1359",
    "de": "static-7.1359",
    "el": "static-7.1359",
    "en-gb": "static-7.1359",
    "en": "static-7.1359",
    "es-mx": "static-7.1359",
    "es": "static-7.1359",
    "et": "static-7.1359",
    "fi": "static-7.1359",
    "fr-ca": "static-7.1359",
    "fr": "static-7.1359",
    "he-il": "static-7.1359",
    "hi": "static-7.1359",
    "hr": "static-7.1359",
    "hu": "static-7.1359",
    "id": "static-7.1359",
    "it": "static-7.1359",
    "ja": "static-7.1359",
    "ko": "static-7.1359",
    "lt": "static-7.1359",
    "ms": "static-7.1359",
    "nl": "static-7.1359",
    "no": "static-7.1359",
    "pl": "static-7.1359",
    "pt-br": "static-7.1359",
    "pt-pt": "static-7.1359",
    "ro": "static-7.1359",
    "ru": "static-7.1359",
    "sk": "static-7.1359",
    "sl": "static-7.1359",
    "sv": "static-7.1359",
    "th": "static-7.1359",
    "tl": "static-7.1359",
    "tr": "static-7.1359",
    "uk": "static-7.1359",
    "vi": "static-7.1359",
    "x-pseudo": "static-7.1359",
    "zh-cn": "static-7.1359",
    "zh-hk": "static-7.1359",
    "zh-tw": "static-7.1359"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sv', {version: 'static-7.1359'}); }
})();



(function() {
  var result = { translations: { "sv": { "videoPlayer": { "htmlTitle": "HubSpot-video", "htmlTitleWithVideo": "{{ videoTitle }} | HubSpot Video", "controls": { "audioPlayer": "Ljudspelare", "videoPlayer": "Videospelare", "play": "Spela upp", "playVideo": "Spela upp video", "pause": "Pausa", "replay": "Repris", "currentTime": "Aktuell tid", "duration": "Varaktighet", "remainingTime": "\xC5terst\xE5ende tid", "fullscreen": "Fullsk\xE4rm", "exitFullscreen": "Avsluta helsk\xE4rm", "mute": "Tysta", "unmute": "Sl\xE5 p\xE5", "volumeLevel": "Volymniv\xE5", "captions": "Bildtexter", "captionsOff": "Av", "seekBar": "Justera position", "chapter": "Kapitel", "elapsedTime": "F\xF6rfluten tid: {{timeDisplay}}" }, "playbackOptions": { "buttonTitle": "Uppspelningsalternativ", "playbackRate": "Uppspelningshastighet:", "quality": "Kvalitet:", "normal": "Normal", "auto": "(Auto)" }, "formModal": { "defaultThankYouMessage": "Tack f\xF6r ditt svar!", "inlineMessageButton": "Se video" }, "ctaModal": { "imgAlt": "Video CTA" }, "errors": { "generic": { "heading": "Kunde inte ladda video" }, "UNAUTHORIZED": { "heading": "Video inte aktiverad" }, "VIDEO_NOT_FOUND": { "heading": "Hittade inte videon" }, "INVALID_URL": { "heading": "Hittade inte videon" }, "UNSUPPORTED_EMBED": { "heading": "Videon \xE4r inte tillg\xE4nglig", "extra": "Den h\xE4r videon kan inte visas externt." }, "refreshLink": "F\xF6rs\xF6k igen" } } } } };
  result.translationsLoaded = {
  "video-player-ui": {
    "sv": "static-1.29208"
  }
};
  result.translationsAvailable = {
  "video-player-ui": {
    "af": "static-1.29208",
    "ar-eg": "static-1.29208",
    "bg": "static-1.29208",
    "bn": "static-1.29208",
    "ca-es": "static-1.29208",
    "cs": "static-1.29208",
    "da": "static-1.29208",
    "de": "static-1.29208",
    "el": "static-1.29208",
    "en-gb": "static-1.29208",
    "en": "static-1.29208",
    "es-mx": "static-1.29208",
    "es": "static-1.29208",
    "et": "static-1.29208",
    "fi": "static-1.29208",
    "fr-ca": "static-1.29208",
    "fr": "static-1.29208",
    "he-il": "static-1.29208",
    "hi": "static-1.29208",
    "hr": "static-1.29208",
    "hu": "static-1.29208",
    "id": "static-1.29208",
    "it": "static-1.29208",
    "ja": "static-1.29208",
    "ko": "static-1.29208",
    "lt": "static-1.29208",
    "ms": "static-1.29208",
    "nl": "static-1.29208",
    "no": "static-1.29208",
    "pl": "static-1.29208",
    "pt-br": "static-1.29208",
    "pt-pt": "static-1.29208",
    "ro": "static-1.29208",
    "ru": "static-1.29208",
    "sk": "static-1.29208",
    "sl": "static-1.29208",
    "sv": "static-1.29208",
    "th": "static-1.29208",
    "tl": "static-1.29208",
    "tr": "static-1.29208",
    "uk": "static-1.29208",
    "vi": "static-1.29208",
    "zh-cn": "static-1.29208",
    "zh-hk": "static-1.29208",
    "zh-tw": "static-1.29208"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:video-player-ui:sv', {version: 'static-1.29208'}); }
})();


